import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { travelCariHref } from '@polatkan/api/travel-cari';
import { trpc } from '@/lib/trpc';
import { TravelCariAccountEditor } from './account-editor';
import { cariTypeLabel } from './cari-type-display';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

/** Every registry type opens the same account editor. */
export function CariCreateModals({
  createType,
  typeLabel,
  onClose,
}: {
  createType: string | null;
  typeLabel?: string;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('travelCari');
  const {
    data: types,
    isLoading,
    refetch,
  } = trpc.travelCariType.list.useQuery(undefined, { enabled: !!createType });
  const type = types?.find((row) => row.code === createType);
  if (!createType) return null;
  if (!type)
    return (
      <Dialog
        open
        onOpenChange={(open) => {
          if (!open) onClose();
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t('account.new')}</DialogTitle>
            <DialogDescription>{createType}</DialogDescription>
          </DialogHeader>
          <p role={isLoading ? 'status' : 'alert'}>
            {t(isLoading ? 'account.loading' : 'account.errors.typeUnavailable')}
          </p>
          {!isLoading && (
            <Button
              variant="outline"
              onClick={() => {
                void refetch();
              }}
            >
              {t('account.retry')}
            </Button>
          )}
        </DialogContent>
      </Dialog>
    );
  return (
    <TravelCariAccountEditor
      key={type.code}
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      type={{
        code: type.code,
        source: type.source === 'customer' ? 'customer' : 'partner',
        label: typeLabel ?? cariTypeLabel(type, i18n.language),
        serviceKind: type.partnerType ?? undefined,
      }}
      onSaved={(account) => navigate(travelCariHref(account.source, account.id))}
    />
  );
}
